import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Grid } from 'semantic-ui-react';
import PaymentCard from './components/PaymentCard';
import { SubscriptionsContextConsumer } from '../../PublishBanner.context';
var defaultProps = {};
export default function PaymentOptions() {
  return /*#__PURE__*/React.createElement(SubscriptionsContextConsumer, null, function (_ref) {
    var subscriptionOptions = _ref.subscriptionOptions,
      _onSelectSubscription = _ref.onSelectSubscription;
    return /*#__PURE__*/React.createElement(Grid, {
      className: "modal-content payment-cards",
      stackable: true,
      columns: subscriptionOptions.length,
      verticalAlign: "bottom"
    }, subscriptionOptions.map(function (subscriptionOption) {
      var priceName = subscriptionOption.priceName;
      return /*#__PURE__*/React.createElement(Grid.Column, {
        className: "payment-column",
        key: priceName
      }, /*#__PURE__*/React.createElement(PaymentCard, _extends({}, subscriptionOption, {
        onSelectSubscription: function onSelectSubscription() {
          return _onSelectSubscription(subscriptionOption);
        }
      })));
    }));
  });
}
PaymentOptions.defaultProps = defaultProps;